import { type MetaFunction } from '@remix-run/node'
import erieandniagara from './erieandniagara.png'

export const meta: MetaFunction = () => [
	{ title: 'Erie and Niagara Insurance Association' },
	{
		name: 'description',
		content: 'We offer insurance from Erie and Niagara Insurance Association.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				Erie and Niagara Insurance Association
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img
					src={erieandniagara}
					alt="Erie and Niagara Insurance Association"
					className="w-64"
				/>

				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Its roots date back to 1875 when a group of farmers banded together to
					create a cooperative assessment company to spread the risk of fire
					loss to their farms.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Erie &amp; Niagara offers a line of products for your small business
					and your family. Commercial offerings include artisan contractors,
					small business, and restaurant. For individuals and families, they
					write coverage for homeowners, farms, landlord properties, and mobile
					homes.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has awarded Erie &amp; Niagara with the financial strength
					rating of A (Excellent).
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.enia.com"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://www.enia.com (opens in a new tab)
					</a>
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Erie &amp; Niagara Online Payment"
						href="https://launchpoint.enia.com/launchpoint/paymentprocessing/payment.aspx"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://launchpoint.enia.com/launchpoint/paymentprocessing/payment.aspx
						(opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					8800 Sheridan Drive
					<br />
					PO Box 9062
					<br />
					Williamsville, NY 14231-9062
					<br />
					<br />
					Billing Telephone: (800) 234-9876
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Erie and Niagara Insurance Association
					<br />
					8800 Sheridan Drive
					<br />
					PO Box 9062
					<br />
					Williamsville, NY 14231-9062
				</p>
			</section>
		</main>
	)
}
